import useWindowSize from 'hooks/useWindowSize';
import { useContext, useEffect, useState } from 'react'
import AppDataContext from '../../context/AppDataContext';
import { MessageProvider } from '../../context/MessageContext';
import Chat from './components/Chat/Chat';
import ChatHistory from './components/ChatHistory/ChatHistory';

export default function Inbox() {
  const { setHeaderShow } = useContext(AppDataContext);
  const { isUltraWide } = useWindowSize(); 
  const [isOpenMessage, setOpenMessage]: any = useState(false);

  // isOpenMessage, setOpenMessage
  useEffect(() => {
    setHeaderShow(false);
  }, []);

  const onOpenMessage = (toggle: boolean)=> {
    setOpenMessage(toggle);
  }


  return (
    <MessageProvider>
      {isUltraWide ? (
        <div className="fh position-relative">
          {isOpenMessage ? (
            <Chat closeHandler={onOpenMessage} />
          ) : (
            <ChatHistory handleOpenMessage={onOpenMessage} />
          )}
        </div>
      ) : (
        <div className="row g-0 fh">
          <div className="col-xl-3 col-md-4">
            <ChatHistory />
          </div>
          <div className="col-xl-9 col-md-8">
            <Chat />
          </div>
        </div>
      )}
    </MessageProvider>
  );
}
